import FacebookAdMark from './facebook-ad-mark@2x.png';
import FacebookLogo from './facebook-logo.svg';
import NationbuilderLogo from './nationbuilder-logo.svg';
import NationbuilderMark from './nationbuilder-mark@2x.png';
import PreziDesignMark from './prezi-design-mark@2x.png';
import PreziLogo from './prezi-logo.svg';
import PromoBarArtwork from './promo-bar-artwork.png';
import SquareLogo from './square-logo.svg';
import SquareOnlineStoreMark from './square-online-store-mark@2x.png';
import SquareWordmark from './square-wordmark.svg';
import SquarespaceLogo from './squarespace-logo.svg';
import SquarespaceMark from './squarespace-mark@2x.png';
import SquarespaceWordmark from './squarespace-wordmark.svg';
import WixLogo from './wix-logo.svg';

export {
    FacebookLogo,
    FacebookAdMark,
    NationbuilderLogo,
    NationbuilderMark,
    PreziLogo,
    PreziDesignMark,
    PromoBarArtwork,
    SquareLogo,
    SquareWordmark,
    SquareOnlineStoreMark,
    SquarespaceLogo,
    SquarespaceMark,
    SquarespaceWordmark,
    WixLogo,
};
